export enum EnumTipoReferencia {
  Lei = 0,
  SumulaVinculante = 1,
  Julgado = 2,
  Informativo = 3,
  ArtigoJuridico = 4,
  QuestaoProva = 5,
  Outros = 6,
  DicasEstudo = 7,
}
